// Shared soundscape/scene metadata used by the Sanctuary player, the Lantern
// composer, and the Lantern recipient page.
export const SCENES = [
  { id: "ocean", name: "Ocean Surf", desc: "Rolling waves breathing in and out." },
  { id: "rain", name: "Soft Rain", desc: "Gentle rainfall on a quiet afternoon." },
  { id: "hearth", name: "Crackling Fire", desc: "A cozy hearth popping and glowing." },
  { id: "stream", name: "Babbling Brook", desc: "A clear stream over smooth stones." },
  { id: "wind", name: "Gentle Wind", desc: "Soft breezes drifting through the valley." },
  { id: "forest", name: "Forest Birdsong", desc: "A dawn chorus deep in the woods." },
  { id: "night", name: "Night Crickets", desc: "A calm summer night's gentle hum." },
  { id: "thunder", name: "Distant Thunder", desc: "Faraway rumbles over steady rain." },
  { id: "chimes", name: "Wind Chimes", desc: "Delicate chimes on a soft breeze." },
  { id: "bowl", name: "Singing Bowl", desc: "Resonant chimes to anchor each breath." },
  { id: "heartbeat", name: "Resting Heartbeat", desc: "A slow, steady beat to settle you." },
  { id: "waves432", name: "432Hz Calm Waves", desc: "A warm, grounding healing tone." },
  { id: "meadow", name: "Summer Meadow", desc: "Breezy grasses and distant songbirds." },
  { id: "rainforest", name: "Rainforest", desc: "Rain, birds and insects in harmony." },
  { id: "drone", name: "Deep Om Drone", desc: "A low meditative drone for stillness." },
  { id: "sleep", name: "Deep Sleep Noise", desc: "Soft, steady noise to drift away." },
];

export const sceneById = (id) => SCENES.find((s) => s.id === id);
